@tailwind base;
@tailwind components;
@tailwind utilities;

:root {
	--jF-theme-color: #19cc76;
	--jF-theme-accent: #142f48;
	--jF-theme-h-text: #142f48;
	--jF-hover-color: #16ac6b;
	--jF-bullet-bg: #bbf7d0;
}

select {
	appearance: none;
	background-image: url("data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20fill='none'%20viewBox='0%200%2020%2020'%3E%3Cpath%20stroke='%236b7280'%20stroke-linecap='round'%20stroke-linejoin='round'%20stroke-width='1.5'%20d='M6%208l4%204%204-4'/%3E%3C/svg%3E");
	background-position: right 0.5rem center;
	background-repeat: no-repeat;
	background-size: 1.5em 1.5em;
	padding-right: 2.5rem;
	-webkit-print-color-adjust: exact;
	print-color-adjust: exact;
}

@layer components {
	.jF-error-text {
		@apply !jF-mt-1 jF-text-xs jF-text-red-600;
	}
	.jF-input-error {
		@apply jF-ring-red-500;
	}
	.jF-input-focus {
		@apply jF-ring-gray-300 focus:jF-ring-[--jF-theme-color] focus:jF-ring-2;
	}
	.jF-input-default {
		@apply jF-block jF-w-full jF-rounded-md jF-shadow-sm jF-border-0 jF-py-2.5 jF-px-2.5 jF-text-gray-900 !jF-ring-1 jF-ring-inset placeholder:jF-text-gray-400 jF-text-base jF-leading-6 jF-bg-none focus:jF-ring-1 focus:jF-ring-inset focus-visible:jF-outline-[--jF-theme-color];
	}
	.jF-select-error {
		@apply jF-ring-red-500;
	}
	.jF-select-focus {
		@apply jF-ring-gray-300 focus:jF-ring-[--jF-theme-color] focus:jF-ring-2;
	}
	.jF-select-default {
		@apply jF-appearance-none jF-bg-white jF-block jF-w-full jF-rounded-md jF-shadow-sm jF-border-0 jF-py-2.5 jF-text-gray-900 !jF-ring-1 jF-ring-inset jF-pl-3 placeholder:jF-text-gray-400 jF-text-base jF-leading-6 focus:jF-ring-1 focus:jF-ring-inset focus-visible:jF-outline-[--jF-theme-color];
	}
	.jF-label {
		@apply jF-block jF-font-semibold jF-text-base jF-leading-6 jF-text-gray-900;
	}
}
